<template>
  <div>
    <transition name="fade"
                mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'base',
    ]),
  },
  // watch: {
  //   $route() {
  //     if (this.sharing) {
  //       this.$store.dispatch('INITIALIZE_APP');
  //       this.sharing = false;
  //     } else {
  //       this.$store.dispatch('ACTION_GAME_ID');
  //       this.$store.dispatch('ACTION_PAGE_TRIGGER');
  //     }
  //   },
  // },
  created() {
    // if ({}.hasOwnProperty.call(this.$route.query, 'sharing')) {
    //   this.sharing = true;
    // }
    this.$store.dispatch('INITIALIZE_APP');
  },
  // mounted() {
  //   document.body.classList.add(this.base.service);
  // },
  data() {
    return {
      // sharing: false,
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue